import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DisplayMissingAssociationBranchFilter = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "customerDataFiltersUI.customerDataFilters.FilterMissingAssociationBranch.filterLabel"
    }), /*#__PURE__*/_jsx(Alert, {
      type: "warning",
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.FilterMissingAssociationBranch.warning"
        })
      })
    })]
  });
};
export default DisplayMissingAssociationBranchFilter;